export const bonuses = [
  {
    number: "01",
    title: "La Boîte à Jeux du Prof de Piano",
    description:
      "Des jeux de rythme, d'oreille et de lecture pour garder l'attention des plus jeunes et rendre chaque cours ludique.",
    value: 17,
    image:
      "https://cdn.magicpatterns.com/uploads/tKtxgxvACzUEqYownwSBWD/1a6bbb80-6681-4711-8883-03e9e7bdd51c-mockup.webp",
  },
  {
    number: "02",
    title: "Les Cartes Musicales à Imprimer",
    description:
      "Des cartes de notes, de clés et de rythmes prêtes à imprimer pour réviser la lecture en quelques minutes.",
    value: 15,
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/39b45d4b-cb73-40ce-b2e1-e81bc4dc4a97.jpg",
  },
  {
    number: "03",
    title: "Mon Premier Petit Récital",
    description:
      "Tout pour préparer vos élèves à jouer en public : calendrier, répertoire et gestion du trac.",
    value: 19,
    image:
      "https://cdn.magicpatterns.com/uploads/g1Ayr8dNpg16iEPMA4LJi3/5e11586d-ba6f-4ad6-b930-2ad167dc2288-mockup.webp",
  },
  {
    number: "04",
    title: "Le Kit de Pratique à la Maison",
    description:
      "Des routines claires et des tableaux de suivi pour que l'élève sache exactement quoi travailler entre deux cours.",
    value: 14,
    image:
      "https://cdn.magicpatterns.com/uploads/eK6NLTGaQP74aReGp5pgWa/1fd27893-5df9-4fab-8440-c464d0e0956b-mockup.webp",
  },
  {
    number: "05",
    title: "Le Kit de Communication avec les Parents",
    description:
      "Modèles de messages, bilans trimestriels et conseils pour impliquer les parents dans la progression.",
    value: 12,
    image:
      "https://cdn.magicpatterns.com/uploads/fo4v3oHf8gwR2EKh9MZDAk/b41db8b6-2aee-45fc-bfe9-3d947c9e6477-mockup.webp",
  },
];
